import { SessionStore } from "../uidispatcherapi/SessionStore";
export const getSessionId = (): string => {
	if (SessionStore.generateSessionedCallTreeIdWithPrefix) {
		const sessionId = SessionStore.generateSessionedCallTreeIdWithPrefix("BTOC");

		if (sessionId) {
			return sessionId;
		}
	}

	return "BTOC" + part() + part() + "-" + part() + "-" + part() + "-" + part() + "-" + part() + part() + part();
};

const part = (): string => {
	return Math.floor((1 + Math.random()) * 0x10000)
		.toString(16)
		.substring(1);
};

export default {
	getSessionId,
};
